(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mootes-black-friday"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mootes-bf-gallery')) {
    customElements.define('mootes-bf-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('[data-viewport]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-go]'));
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.current = this.querySelector('[data-current]');
        if (!this.viewport || this.slides.length < 2) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.go = (index) => {
          const target = Math.max(0, Math.min(this.slides.length - 1, index));
          const left = this.slides[target].offsetLeft - this.slides[0].offsetLeft;
          this.viewport.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.update = () => {
          const left = this.viewport.getBoundingClientRect().left;
          this.index = this.slides.reduce((nearest, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[nearest].getBoundingClientRect().left - left) ? index : nearest, 0);
          this.previous.disabled = this.index === 0;
          this.next.disabled = this.index === this.slides.length - 1;
          this.current.textContent = String(this.index + 1);
          this.dots.forEach((dot, index) => {
            if (index === this.index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        };
        this.previous.addEventListener('click', () => this.go(this.index - 1), options);
        this.next.addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.go)), options));
        this.viewport.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(this.update, 100);
        }, { ...options, passive: true });
        this.viewport.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home') this.go(0);
          else if (event.key === 'End') this.go(this.slides.length - 1);
          else this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.resizeObserver = new ResizeObserver(() => {
          if (!this.viewport.clientWidth) return;
          const left = this.slides[this.index].offsetLeft - this.slides[0].offsetLeft;
          this.viewport.scrollTo({ left, behavior: 'instant' });
          this.update();
        });
        this.resizeObserver.observe(this.viewport);
        this.querySelector('[data-controls]').hidden = false;
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        clearTimeout(this.scrollTimer);
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
